import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  liveClassData: [],
  totalliveClass: 0,
  isOpenModal: false,
}

export const liveClassSlice = createSlice({
  name: "liveClass",
  initialState,
  reducers: {
    setliveClassData(state, { payload }) {
      state.liveClassData = payload
    },
    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
  }
})

export const { setliveClassData, isOpenModal,  ModalToggle } = liveClassSlice.actions;

export default liveClassSlice.reducer;

export function getliveClass(id) {
  return async function getliveClassThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getliveClass(id).then(
        (response) => {         
          dispatch(setLoading(false))
          dispatch(setliveClassData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addliveClass(data, id) {
  return async function addliveClassThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addliveClass(data).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          successHandler('Added Successfully')
            dispatch(getliveClass(id));
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}



